<template>
  <div class="issue-order-top-wrap">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchObj">
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-plus" @click="openAdd">新增推荐</el-button>
        </el-form-item>
        <el-form-item label="推荐标题">
          <el-input v-model="searchObj.title" placeholder="模糊搜索" clearable style="width: 160px;" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchObj.status" placeholder="全部" clearable style="width: 100px;">
            <el-option label="全部" :value="''" />
            <el-option label="上架" :value="1" />
            <el-option label="下架" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="loadList">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table-wrap">
      <el-table size="small" :data="list">
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="issue_order_id" label="对单ID" width="90" />
        <el-table-column prop="title" label="推荐标题" min-width="180" show-overflow-tooltip />
        <el-table-column label="业务类型" width="100">
          <template slot-scope="scope">{{ bizTypeText(scope.row.biz_type) }}</template>
        </el-table-column>
        <el-table-column label="发单用户" width="160">
          <template slot-scope="scope">
            <span v-if="scope.row.user">{{ scope.row.user.nickName }} (ID:{{ scope.row.user.user_id }})</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="90">
          <template slot-scope="scope">
            <el-tag size="small" :type="scope.row.status === 1 ? 'success' : 'info'">
              {{ scope.row.status === 1 ? '上架' : '下架' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="添加时间" width="160" />
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="doDelete(scope.row)">删除</el-button>
            <el-button
              v-if="scope.row.status === 1"
              type="text"
              size="small"
              @click="doChangeStatus(scope.row, 0)"
            >下架</el-button>
            <el-button
              v-if="scope.row.status === 0"
              type="text"
              size="small"
              @click="doChangeStatus(scope.row, 1)"
            >上架</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
        @current-change="pageChange"
        background
        :current-page="searchObj.page"
        :page-size="searchObj.list_rows"
        layout="total, prev, pager, next, jumper"
        :total="total"
      />
    </div>

    <!-- 新增弹窗 -->
    <el-dialog title="新增推荐" :visible.sync="addVisible" width="500px">
      <el-form :model="addForm" label-width="100px" size="small">
        <el-form-item label="对单ID">
          <el-input-number v-model="addForm.issue_order_id" :min="1" placeholder="对单ID" style="width: 100%;" />
        </el-form-item>
        <el-form-item label="推荐标题">
          <el-input v-model="addForm.title" placeholder="推荐展示标题，可留空使用对单原标题" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false">取消</el-button>
        <el-button type="primary" :loading="addLoading" @click="submitAdd">确定</el-button>
      </div>
    </el-dialog>

    <!-- 编辑弹窗 -->
    <el-dialog title="编辑推荐" :visible.sync="visible" width="500px">
      <el-form :model="form" label-width="100px" size="small">
        <el-form-item label="推荐标题">
          <el-input v-model="form.title" placeholder="对单推荐标题" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">上架</el-radio>
            <el-radio :label="0">下架</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="submitEdit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import IssueOrderApi from '@/api/issueorder'
import {
  MAIN_KEY,
  fetchLabelValueOptions,
  FALLBACK_ISSUE_ORDER_BIZ_TYPE_LIST,
  bizTypeTextFromOptions,
} from '@/utils/sysEnumOptions'

export default {
  name: 'IssueOrderTop',
  data() {
    return {
      bizTypeList: [...FALLBACK_ISSUE_ORDER_BIZ_TYPE_LIST],
      searchObj: {
        page: 1,
        list_rows: 15,
        title: '',
        status: ''
      },
      list: [],
      total: 0,
      visible: false,
      loading: false,
      form: {
        id: 0,
        title: '',
        status: 1
      },
      addVisible: false,
      addLoading: false,
      addForm: {
        issue_order_id: null,
        title: ''
      }
    }
  },
  created() {
    fetchLabelValueOptions(MAIN_KEY.issueOrderBizType, { stringValue: true }, FALLBACK_ISSUE_ORDER_BIZ_TYPE_LIST)
      .then(list => { this.bizTypeList = list })
      .catch(() => {})
    this.loadList()
  },
  methods: {
    bizTypeText(bizType) {
      return bizTypeTextFromOptions(bizType, this.bizTypeList) || '-'
    },
    loadList() {
      IssueOrderApi.topIndex(this.searchObj).then(res => {
        if (res.data && res.data.list) {
          const list = res.data.list
          this.list = list.data || list
          this.total = list.total != null ? list.total : (this.list.length || 0)
        }
      }).catch(() => {})
    },
    pageChange(page) {
      this.searchObj.page = page
      this.loadList()
    },
    openEdit(row) {
      this.form = {
        id: row.id,
        title: row.title,
        status: row.status
      }
      this.visible = true
    },
    submitEdit() {
      this.loading = true
      IssueOrderApi.topEditSubmit({
        id: this.form.id,
        title: this.form.title,
        status: this.form.status
      }).then(res => {
        this.loading = false
        if (res.code === 1) {
          this.$message.success(res.msg || '更新成功')
          this.visible = false
          this.loadList()
        } else {
          this.$message.error(res.msg || '更新失败')
        }
      }).catch(() => { this.loading = false })
    },
    doDelete(row) {
      this.$confirm('确定删除该推荐记录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        IssueOrderApi.topDelete({ id: row.id }).then(res => {
          if (res.code === 1) {
            this.$message.success(res.msg || '删除成功')
            this.loadList()
          } else {
            this.$message.error(res.msg || '删除失败')
          }
        }).catch(() => {})
      }).catch(() => {})
    },
    doChangeStatus(row, status) {
      const action = status === 1 ? '上架' : '下架'
      this.$confirm('确定' + action + '该推荐？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        IssueOrderApi.topChangeStatus({ id: row.id, status }).then(res => {
          if (res.code === 1) {
            this.$message.success(res.msg || action + '成功')
            this.loadList()
          } else {
            this.$message.error(res.msg || action + '失败')
          }
        }).catch(() => {})
      }).catch(() => {})
    },
    openAdd() {
      this.addForm = { issue_order_id: null, title: '' }
      this.addVisible = true
    },
    submitAdd() {
      if (!this.addForm.issue_order_id || this.addForm.issue_order_id < 1) {
        this.$message.warning('请输入对单ID')
        return
      }
      this.addLoading = true
      IssueOrderApi.topAdd({
        issue_order_id: this.addForm.issue_order_id,
        title: (this.addForm.title || '').trim()
      }).then(res => {
        this.addLoading = false
        if (res.code === 1) {
          this.$message.success(res.msg || '添加成功')
          this.addVisible = false
          this.loadList()
        } else {
          this.$message.error(res.msg || '添加失败')
        }
      }).catch(() => { this.addLoading = false })
    }
  }
}
</script>

<style lang="scss" scoped>
.issue-order-top-wrap { padding: 10px; }
.pagination { margin-top: 12px; }
</style>



// WEBPACK FOOTER //
// src/views/issueorder/top/index.vue